module.exports = __webpack_public_path__ + "static/media/Puffy Wireframe.721cf98d.png";